import React from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { BookOpen } from "lucide-react";
import { STAFF_STATUS_COLORS } from "variables/constants";
import Badge from "components/badge";
import CrudOption from "components/dropdown/crudoption";
import TrainingModuleForm from "./TrainingModuleForm";
import {
    doTrainingModuleDelete
} from "../../../../redux/trainingmodule/trainingModuleState";


const TrainingModuleCard = ({
    recordData,
    showStat = true,
    showResult = false,
    doDelete
}) => {
    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border border-slate-200">
            <div className="p-6">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
                    <div className="lg:col-span-4">
                        <div className="flex items-start gap-3 mb-2">
                            <div className="p-2 rounded-lg bg-gradient-to-br from-green-500 to-purple-600">
                                <BookOpen className="w-5 h-5 text-white" />
                            </div>
                            <div className="flex-1">
                                <h3 className="font-semibold mb-1">
                                    {recordData?.trm_title || recordData?.module_name}
                                </h3>
                                <p className="text-[12px] text-slate-700 mb-2">
                                    {recordData?.training_module?.trm_description || recordData?.trm_description}
                                </p>
                            </div>
                        </div>
                    </div>
                    {(showStat && 
                        <>
                            <div className="lg:col-span-8">
                                <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-8 gap-4 items-start">
                                    <div className="md:col-span-1 lg:col-span-2">
                                        <p className="text-[11px] text-slate-700 mb-1">
                                            Question Items
                                        </p>
                                        <p className="text-[18px] font-semibold text-blue-600">
                                            {recordData?.trm_question_items}
                                        </p>
                                    </div>
                                    <div className="md:col-span-1 lg:col-span-2">
                                        <p className="text-[11px] text-slate-700 mb-1">
                                            Passing Score
                                        </p>
                                        <p className="text-[18px] font-semibold text-green-600">
                                            {recordData?.passing_score}
                                        </p>
                                    </div>
                                    <div className="md:col-span-1 lg:col-span-2">
                                        <p className="text-[11px] text-slate-700 mb-1">
                                            Allowed Attempt
                                        </p>
                                        <p className="text-[18px] font-semibold text-orange-600">
                                            {recordData?.trm_allowed_attempt}
                                        </p>
                                    </div>
                                    <div className="md:col-span-1 lg:col-span-1">
                                        <p className="text-[11px] text-slate-700 mb-2">
                                            Status
                                        </p>
                                        <div className="inline-block">
                                            <Badge color={STAFF_STATUS_COLORS[recordData?.trm_status_name]}>
                                                {recordData?.trm_status_name}
                                            </Badge>
                                        </div>
                                    </div>
                                    <div className="md:col-span-1 lg:col-span-1">
                                        <p className="text-[11px] text-slate-700 mb-2">
                                            Action
                                        </p>
                                        <div className="inline-block rounded-xl border px-2 py-1 text-xs">
                                            <CrudOption 
                                                baseRoute="/console/training-modules" 
                                                recordId={recordData?.trm_id} 
                                                allowView={false}
                                                deleteHandler={doDelete}
                                                editMode="modal"
                                                title="Edit Training Module"
                                                editHandler={(recordId, onClose) => (
                                                    <TrainingModuleForm
                                                        recordId={recordId}
                                                        mode="edit"
                                                        onCancel={onClose}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {(showResult && 
                        <div className="lg:col-span-8">
                            <div className="grid grid-cols-6 gap-4">
                                <div className="col-span-2">
                                    <p className="text-[11px] text-slate-700 mb-1">
                                        Participant Name
                                    </p>
                                    <p className="text-[18px] font-semibold text-blue-600">
                                        {recordData?.participant_name}
                                    </p>
                                </div>
                                <div>
                                    <p className="text-[11px] text-slate-700 mb-1">
                                        Passing Score
                                    </p>
                                    <p className="text-[18px] font-semibold text-green-600">
                                        {recordData?.training_module?.passing_score}
                                    </p>
                                </div>
                                <div>
                                    <p className="text-[11px] text-slate-700 mb-1">
                                        Final Score
                                    </p>
                                    <p className="text-[18px] font-semibold text-green-600">
                                        {recordData?.trs_score}
                                    </p>
                                </div>
                                <div>
                                    <p className="text-[11px] text-slate-700 mb-1">
                                        Attempt
                                    </p>
                                    <p className="text-[18px] font-semibold text-orange-600">
                                        {recordData?.trs_attempt}
                                    </p>
                                </div>
                                <div className="inline-block mr-6">
                                    <p className="text-[11px] text-slate-700 mb-1">
                                        Result
                                    </p>
                                    <p
                                        className={`text-[18px] font-semibold ${
                                            recordData?.trs_is_passed ? "text-green-600" : "text-red-600"
                                        }`}
                                    >
                                        {recordData?.trs_is_passed ? "Passed" : "Failed"}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  	doDelete: (id) => dispatch(doTrainingModuleDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingModuleCard);
